import { InjectionToken } from '@angular/core';
import { PollingHandlerService } from '../../features/leads/services/polling-handler.service';

export const UPLOAD_POLLING = new InjectionToken<PollingHandlerService>('Upload polling service');
export const EXPORT_POLLING = new InjectionToken<PollingHandlerService>('Export polling service');
